import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export const detectIsMobileWidth = () => globalThis.innerWidth <= 900;

interface SliceAppState {
  title: string;
  isMobile: boolean;
  icareKo: boolean;
}

const initialState: SliceAppState = {
  title: '',
  isMobile: detectIsMobileWidth(),
  icareKo: false,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  extraReducers: builder => builder.addCase('resetStore', () => initialState),
  reducers: {
    updateTitle: (state, action: PayloadAction<string>) => {
      state.title = action.payload;
    },
    setIsMobile: (state, action: PayloadAction<boolean>) => {
      state.isMobile = action.payload;
    },
    setIcareKo: (state, action: PayloadAction<boolean>) => {
      state.icareKo = action.payload;
    },
  },
});

export const {
  reducer: appReducer,
  actions: { updateTitle, setIsMobile, setIcareKo },
} = appSlice;
